import axios,{ AxiosResponse } from 'axios'
import { ElNotification, ElMessageBox } from 'element-plus'
import router from "@/router";
import { getToken } from '@/utils/auth'
import {createLogger} from "vuex";
// 创建axios实例
const service = axios.create({
    // baseURL:'http://192.168.1.51:18090/',
    baseURL: process.env.VUE_APP_SERVER_API,
    timeout: 12000 // 请求超时时间
  })

  // request拦截器
  service.interceptors.request.use(
    config => {
       if(getToken() == undefined){
           router.push({path:'/login'})
       }
      config.headers['Authorization'] = `Bearer ${getToken()}`
      // config.headers['Content-Type'] = 'application/json'
      config.headers['Content-Type'] = 'application/json;'
      return config
    },
    error => {
      // Do something with request error
      console.log(error) // for debug
      router.push({path:'/login'})
      Promise.reject(error)
    }
  )

  // response 拦截器
  service.interceptors.response.use(
    response => {
        console.log(response,8888)
      const code = response.status
      if (code < 200 || code > 300) {
          console.log("呵呵很大11")
        ElNotification.error({
          title: "验证失效"
        })
        router.push({path:'/login'})
      } else {
        if (response.data.code == "200" || response.config.responseType == 'blob') {
          return response.data
        }else {
          if(response.data.code==401){
              ElNotification.error({
                  title: response.data.msg==null?'请求错误':response.data.msg,
                  duration: 5000
              })
              router.push({path:'/login'})
          }
          ElNotification.error({
            title: response.data.msg==null?'请求错误':response.data.msg,
            duration: 5000
          })
          return Promise.reject('error')
        }
      }
    },
    error => {
        console.log(error.response,999)
      let code = 0
      try {
        code = error.response.status
      } catch (e) {
        if (error.toString().indexOf('Error: timeout') !== -1) {
            ElNotification.error({
            title: '网络请求超时',
            duration: 5000
          })
          return Promise.reject(error)
        }
      }
      if (code) {

        if (code === 401) {
            ElMessageBox.confirm(
            '登录状态已过期，您可以继续留在该页面，或者重新登录',
            '系统提示',
            {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {
                router.push({path:'/login'})
          })
        }
        else if (code === 500) {
            router.push({path:'/login'})
        }
      } else {
        // Notification.error({
        //   title: '接口请求失败',
        //   duration: 5000
        // })
      }
      return Promise.reject(error)
    }
  )
  export default service
